import(/* webpackMode: "eager" */ "/vercel/path0/apps/app/app/error.tsx");
